import { render, staticRenderFns } from "./QuestionTagFormDialog.vue?vue&type=template&id=43122416&"
import script from "./QuestionTagFormDialog.vue?vue&type=script&lang=ts&"
export * from "./QuestionTagFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports